var get_id_pro = $('div#pricing_options').data('id');
var base_url = 'https://phpstack-640073-2084255.cloudwaysapps.com';
// var base_url = 'http://127.0.0.1:8000';

if(get_id_pro){
  $.ajax({
    url:base_url+"/api/product/"+get_id_pro,
    type: 'GET',
    success: function(res){
      $('div#pricing_options').append(res.pricing);
      $('#custom_options_wrapper').append(res.options_html);
      $('#custom_options_wrapper').append(res.personalization);
      $('.total_product_price').show();
      AppendSpecialProduct();


      var activeLbelColor = $('.variant-input input[name="Color"]:checked').val()
      $('.tetra_append_input span.previewtext').css("background",ColorsAvalible[activeLbelColor]);
      if((activeLbelColor=='White')||(activeLbelColor=='Yellow'))
      {
        $('.tetra_append_input span.previewtext').css("color","black")
      }
      else
      {
        $('.tetra_append_input span.previewtext').css("color","white")
      }

    }
  })
}



//     $('body').on('click','.tetra_custom_option_swatches .single_swatche_opt',function(){
//       if($(this).parents('.tetra_custom_option_inner').hasClass('active')){
//         $(this).parents('.tetra_custom_option_inner').find('.single_swatche_opt').removeClass('active');
//         $(this).addClass('active');
//         $(this).parents('.tetra_custom_option_inner').find('.tetra_container p').text('('+$(this).data('price')+')');

//       }
//     });

$('body').on('change','.tetra_container input',function(){
  //           $('.tetra_custom_option_inner').removeClass('active');
  //           $(this).parents('.tetra_custom_option_inner').addClass('active');
  //           $('.single_swatche_opt').removeClass('active');
  //           $(this).parents('.tetra_custom_option_inner').find('.single_swatche_opt').eq(0).click();
  set_price();
  calculatePrice();
});

$('body').on('change','#custom_options_wrapper .tetra_select_option input[type="file"]',function(){
  $(this).next().val($(this).data('price'));
});

$('body').on('change','.tetra_select_option select',function(){
  var haveoption = $(this).children("option:selected").data('sub');
  var option_price = $(this).children("option:selected").data('price');
  var sub_option_type = $(this).children("option:selected").data('sub-type');
  var sub_option_price = $(this).children("option:selected").data('sub-price');
  var sub_option_label = $(this).children("option:selected").data('sub-label');
  var get_property = $(this).data('label');
  var get_class = $(this).data('id');
  if(haveoption){
    $(this).parent().find('label p').text('(+$'+option_price+')');
    $(this).parent().append('<div class="'+get_class+'"><label>'+sub_option_label+'</label>\
<input type="'+sub_option_type+'" required name="properties['+get_property+'-'+sub_option_type+']" data-price="'+option_price+'">\
<input type="hidden" name="properties[Logo Charges '+sub_option_label+']" data-price="'+option_price+'"></div>');
  }
  else{
    $(this).parent().find('label p').text('');
    $(this).parent().find('.'+get_class).remove();
  }
});


$('body').on('change','.tetra_personalise_option select#teta_personalise_1',function(){
  if($(this).val() == 'Yes'){
    $('.show_if_custom_radio').css('display','inline-block');
    $('.show_if_custom_radio input[type="radio"]').attr('name', $('.show_if_custom_radio input[type="radio"]').attr('data-name'));
    $('.engravingpad input').each(function(){
      $(this).attr('name', $(this).attr('data-name'));
    });
  }else{
    $('.show_if_custom_radio').css('display','none');
    $('.show_if_custom_radio input[type="radio"]').attr('name', $('.show_if_custom_radio input[type="radio"]').attr('data-a-name'));
    $('.engravingpad input').each(function(){
      $(this).attr('name', $(this).attr('data-a-name'));
    });
  }
});

// change Same for All and Different
$('body').on('change','.custom_select_yes div input[type="radio"]',function(){
  var get_all_opt_length = $('.custom_original_copy p.engravingpad').length;
  var get_input_feld_length = $(this).parents('.custom_select_yes').find('input[type="hidden"]').length;
  if(get_input_feld_length < 1){
    $(this).parents('.custom_select_yes').append('<input type="hidden" value="'+get_all_opt_length+'" name="properties[Engraving Length]">');
  }
  var get_vals = $(this).val();
  var get_total_qty = parseInt($('form[action="/cart/add"] input[name="quantity"]').val());
  if(get_vals == 'Different'){
    $('.tetra_append_input').addClass('add_extra');
    setTimeout(function(){
      $('.add_extra p.engravingpad input').each(function(){
        var get_parent_index = $(this).parents('div').data('index');
        var get_label = $(this).data('label');
        $(this).attr('name','properties[Product'+get_parent_index +' '+get_label+']')
        $(this).attr('data-name','properties[Product'+get_parent_index +' '+get_label+']')
        $(this).attr('data-a-name','Product'+get_parent_index +' '+get_label);
      });
    }, 100);
  }
  else{
    $('p.engravingpad input').each(function(){
      var get_parent_index = $(this).parents('div').data('index');
      var get_label = $(this).data('label');
      $(this).attr('name','properties[Product'+get_parent_index +' '+get_label+']')
      $(this).attr('data-name','properties[Product'+get_parent_index +' '+get_label+']')
      $(this).attr('data-a-name','Product'+get_parent_index +' '+get_label)
    });
    $('.tetra_append_input').removeClass('add_extra');
  }
  $('.tetra_append_input').attr("data-status", get_vals);
  $('.tetra_append_input').css('display','inline-block');
});

//     in Preview mode

$('body').on('input','p.engravingpad input',function(e){
  $(this).parent().find('.previewtext').text($(this).val());
});


// repeat text 
$('body').on('click','span.custom_repeat_text',function(e){
  $(this).toggleClass("active");
  var selector = $(this); 
  setTimeout(function(){
    replace_text(selector);
  }, 50);
});

$('body').on('change','form[action="/cart/add"] input[name="quantity"]',function(e){
  var get_total_qty = parseInt($('form[action="/cart/add"] input[name="quantity"]').val());
  var get_clone = $('.tetra_append_input .custom_original_copy').html();
  if(get_total_qty => 1){
    $('.tetra_append_input .custom_original_copy total').text(get_total_qty);
    $('.tetra_append_input .custom_append_opt').remove();
    for (var i = 2; i <= get_total_qty; i++) {
      $('.tetra_append_input').append('<div class="custom_append_opt" data-index="'+i+'">'+get_clone+'</div>');
      $('.tetra_append_input .custom_append_opt[data-index='+i+']').find('.engravingheading').text('Engraving '+i+' of '+get_total_qty);
      $('.tetra_append_input .custom_append_opt[data-index='+i+']').find('.custom_repeat_text').remove();
      $('.tetra_append_input .custom_append_opt[data-index='+i+']').find('.previewtext').text('');
      $('.tetra_append_input .custom_append_opt[data-index='+i+']').find('input').val('');
    }
    $('.add_extra p.engravingpad input').each(function(){
      var get_parent_index = $(this).parents('div').data('index');
      var get_label = $(this).data('label');
      $(this).attr('name','properties[Product'+get_parent_index +' '+get_label+']');
      $(this).attr('data-name','properties[Product'+get_parent_index +' '+get_label+']');
      $(this).attr('data-a-name','Product'+get_parent_index +' '+get_label);
    });

    $('span.custom_repeat_text').each(function(){
      var selector = $(this);
      replace_text(selector);
    });
  }

  set_price();
  calculatePrice();
  RepeartFields(get_total_qty);
});


var checkaPPend = []

$('.custom_tetra_edit_btn').click(function(){
  $(this).parent().toggleClass('update_activated');
  var get_cart_length = $(this).parents('.cart__row').find('.input_leng').data('length');
  var get_cart_status = $(this).parents('.cart__row').find('.personalise_status').data('last');
  var get_item_qty = $(this).parents('.cart__row').find('input[type="number"]').val();

  if(get_cart_status == 'Same'){
    $(this).parents('.cart__row').find('p.custom_properties1').each(function(index, value){
      index = index+1;
      $(this).parents('.cart__row').find('.custom_inputs_append_opt').append('<div class="custom_pro_div"><label>Line '+index+'</label><input name="properties['+$(this).data('first')+']" value="'+$(this).data('last')+'"  maxlength="40"></div>');
    });
    $(this).parents('.cart__row').find('.custom_inputs_append_opt').show();
  }
  else{

    checkaPPend = []
    var newarray = []
    $(this).parents('.three-quarters').find('.custom_tetra_updated_line_items p').each(function(index,value){

      newarray =  checkaPPend.push($(this).attr('data-head'))

    })


    var checkarr=[];
    var checkValue
    get_cart_length = get_cart_length * get_item_qty;
    $(this).parents('.cart__row').find('p.custom_properties1').each(function(index, value){
      //           index = 0
      //           index = index+1

      if(checkarr.length==0)
      {
        checkarr.push(value);
      }

      checkValue = checkaPPend[index]
      if(index==0)
      {
        checkValue =  checkaPPend[0]
      }
      else if( checkValue == checkaPPend[index-1] )
      {
        checkValue = ''
      }
      else
      {
        checkValue=checkaPPend[index]
      }
      $(this).parents('.cart__row').find('.custom_inputs_append_opt').append('<div class="custom_pro_div"><h1 class="checkHeading">'+checkValue+'</h1><label>'+$(this).data('first')+'</label><input name="properties['+$(this).data('first')+']" value="'+$(this).data('last')+'"  maxlength="40"></div>');
    });


    $(this).parents('.cart__row').find('.custom_inputs_append_opt').show();

    var get_selector = $(this);
    setTimeout(function(){
      get_selector.parents('.cart__row').find('.custom_pro_div').each(function(index, value){
        index = index+1;
        if(index > get_cart_length){
          $(this).remove();
        }
      });
    },50);
  }
});

checkaPPend=[];

$('body').on('click','.update_activated .custom_tetra_update_btn',function(){
  $(this).addClass('btn--loading');
  var get_item_key = $(this).parents('.cart__row').data('line');
  var get_item_id = $(this).parents('.cart__row').data('id');
  var get_item_qty = $(this).parents('.cart__row').find('input[type="number"]').val();
  var get_properties = '';
  $(this).parents('.cart__row').find('.custom_properties').each(function(){
    var get_first = "properties["+$(this).data('first')+"]";
    var get_last = $(this).data('last');
    var get_final_string = get_first+'='+get_last;
    get_properties = get_properties+get_final_string+'&'
  });
  $(this).parents('.cart__row').find('.custom_pro_div input').each(function(){
    var get_first = "properties["+$(this).prev().text()+"]";
    var get_last = $(this).val();
    var get_final_string = get_first+'='+get_last;
    get_properties = get_properties+get_final_string+'&'
  });
  get_properties = get_properties.slice(0,-1);

  $.ajax({
    url: '/cart/change.js',
    type: 'post',
    dataType: 'json',
    data: {
      line: get_item_key,
      quantity: 0
    },
    success: function(cart){
      $.ajax({
        url: '/cart/add.js',
        type: 'post',
        dataType: 'json',
        data: 'quantity='+get_item_qty+'&id='+get_item_id+'&'+get_properties,
        success: function(cart){
          location.reload(true);
        }
      });
    }
  });
});


function set_price(){
  var qty = $('form[action="/cart/add"] input[name="quantity"]').val();
  var selected = 0;
  $('#pricing_options input[type="radio"]:checked').parents('.tetra_custom_option_inner').find('.single_swatche_opt').each(function(){
    var max_qty = $(this).data('max-qty');
    var min_qty = $(this).data('min-qty');
    var price = $(this).data('price');
    if(qty == min_qty){
      selected = price;
    }else if(qty > min_qty){
      selected = price;
    }
    if(qty >= min_qty && qty <= max_qty){
      selected = price;
    }
  });
  $('input#calculated_price').val(selected);
  $('.product_price').html('<span class="money">$'+selected+'</span>');
  return false;
}

function replace_text(selector){
  var get_index = selector.parent().data('position');
  var get_val = selector.prev().val();
  if(selector.hasClass('active')){
    selector.parents('.tetra_append_input').find('p.engravingpad.repeat[data-position='+get_index+'] input').val(get_val);
    selector.parents('.tetra_append_input').find('p.engravingpad.repeat[data-position='+get_index+'] .previewtext').text(get_val);
  }
  else{
    selector.parents('.tetra_append_input').find('p.engravingpad.repeat[data-position='+get_index+'] input').val('');
    selector.parents('.tetra_append_input').find('p.engravingpad.repeat[data-position='+get_index+'] .previewtext').text('');

    selector.prev().val(get_val);
    selector.next().text(get_val);
  }
}


//     var base_url = 'https://phpstack-176572-1280148.cloudwaysapps.com';

$('body').on('change','.main_option_select > label > .checkbox', function(){
  if($(this).is(':checked')){
    if($(this).attr('data-child-enable') == 'true'){
      $(this).parent().next().show();      
    }else{
      $(this).parent().next().hide();
    }
    //         $(this).parent().next().show();
    $(this).parent().next().find('.has_sub_option_input').each(function(){
      $(this).attr('name', $(this).attr('data-name'));
    });

    $(this).parent().next().find('.tt_option').each(function(){
      var required = $(this).attr('data-required');
      if(required == 1){
        $(this).attr('required','required');
      }else{
        $(this).removeAttr('required');
      }
    });

  }else{
    $(this).parent().next().hide();
    $(this).parent().next().find('.has_sub_option_input').each(function(){
      $(this).attr('name', $(this).attr('data-a-name'));
    });

    $(this).parent().next().find('.tt_option').each(function(){
      $(this).removeAttr('required');
    });
  }

  calculatePrice();

});


$('body').on('change','.main_option_select  select', function(){

  var $target = $(this).find('option[value="'+$(this).val()+'"]').attr('data-target');
  var $has_child = $(this).find('option[value="'+$(this).val()+'"]').attr('data-child-enable');
  if($has_child == 'true'){
    $(this).next().show();
  }else{
    $(this).next().hide();  
  }

  if($(this).hasClass('has_personalization')){

    var current_value = $(this).parents('.sub_options_data').prev().val();
    if(current_value == "Yes" || current_value == 'yes'){
      $(this).parent().siblings('.sub_personalization_option').show();
    }else{
      $(this).parent().siblings('.sub_personalization_option').hide();
    }
    console.log(current_value);

  }else{
    var $personalization = $(this).find('option[value="'+$(this).val()+'"]').attr('data-personalization');
    if($personalization == 'true'){
      $(this).next().find('.sub_option_data').each(function(){
        if($(this).hasClass('sub_personalization_option')){
          $(this).show();
        }else{
          $(this).hide();
        }
      });
    }else{
      $(this).next().find('.has_sub_option_input').each(function(){
        if($(this).parent().attr('data-target') == $target){
          $(this).attr('name', $(this).attr('data-name'));
          $(this).parent().show();
        }else{
          $(this).parent().hide();
          $(this).attr('name', $(this).attr('data-a-name'));
        }
      });
      $(this).parent().siblings('.sub_personalization_option').hide();
      $(this).next().find('.sub_personalization_option').hide();
    }
  }

  calculatePrice();

  var $this = $(this);
  var $this_value = $(this).val();
  var data_price = $(this).find('option[value="'+$this_value+'"]').attr('data-price');
  var data_unit = $(this).find('option[value="'+$this_value+'"]').attr('data-price-unit');
  var date_bg_color = $(this).find('option[value="'+$this_value+'"]').attr('data-bg-color');
  var date_bg_image = $(this).find('option[value="'+$this_value+'"]').attr('data-bg-image');
  var data_price_label = $(this).find('option[value="'+$this_value+'"]').attr('data-price-label');

  if(data_price_label && data_price != 0){
    //     if(data_unit == 'all'){
    //       $this.prev().find('.option_price').html('($'+data_price+' for all quantities)');
    //     }

    //     if(data_unit == 'per_unit'){
    //       $this.prev().find('.option_price').html('($'+data_price+' per unit quantity)');
    //     }

    $this.prev().find('.option_price').html('('+data_price_label+')');

  }else{
    $this.prev().find('.option_price').html('');
  }

  if(date_bg_image){
    var images = date_bg_image.split(',');
    var images_html = '';
    images.forEach(function(item, index){
      images_html += '<a href="'+item+'" data-fancybox="images"><img style="max-width:50px;margin-right:2px;" src="'+item+'"></a>';        
    });

    $this.prev().find('.option_color').html('<div class="image_swatch" style="display:inline-block;">'+images_html+'</div>');

  }else{
    if(date_bg_color){
      $this.prev().find('.option_color').html('<div class="swatch" style="background:'+date_bg_color+';"></div>');
    }else{
      $this.prev().find('.option_color').empty();
    }
  }

  // enable required

  console.log($target)

  $(this).next().find('.has_sub_option_input').each(function(){
    if($(this).parent().attr('data-target') == $target){
      $(this).attr('name', $(this).attr('data-name'));
      $(this).parent().show();

      var required = $(this).attr('data-required');
      if(required == 1){
        $(this).attr('required','required');
      }else{
        $(this).removeAttr('required');
      }

    }else{
      $(this).parent().hide();
      $(this).attr('name', $(this).attr('data-a-name'));
      $(this).removeAttr('required');
    }
  });

});

$('body').on('change','select.has_personalization',function(){
  var get_selector = $(this).find("option:selected");
  $('p.engravingpad span.previewtext').css('background-color',get_selector.data('bg-color'));
  $('p.engravingpad span.previewtext').css('color',get_selector.data('color'));

});


function calculatePrice(){
  var quantity = $('.product__quantity input').val();
  var per_unit_price = 0;
  var all_price = 0;

  // for select
  $('.main_option_select.level_1  select').each(function(){
    var $value = $(this).val();
    if($value){
      var $price = parseFloat($(this).find('option[value="'+$value+'"]').attr('data-price'));
      if($price > 0){
        var $price_unit = $(this).find('option[value="'+$value+'"]').attr('data-price-unit');
        if($price_unit == 'per_unit'){
          per_unit_price = per_unit_price + $price;
        }
        if($price_unit == 'all'){
          all_price = all_price + $price;
        }
      }
    }
  });


  // for checkboxes

  $('.main_option_select.level_1 > label > .checkbox').each(function(){
    if($(this).is(':checked')){
      var $price = parseFloat($(this).attr('data-price'));
      if($price > 0){
        var $price_unit = $(this).attr('data-price-unit');
        if($price_unit == 'per_unit'){
          per_unit_price = per_unit_price + $price;
        }
        if($price_unit == 'all'){
          all_price = all_price + $price;
        }        
      }
    }
  });

  $('#per_unit_price').val(per_unit_price.toFixed(2));
  $('#all_price').val(all_price.toFixed(2));
  CalculateFinalPrice();
}

$('body').on("click", "#checkout_submit", function(e){
  e.preventDefault();
  var $btn = $(this);
  $btn.addClass('disabled');
  jQuery.getJSON('/cart.js', function(cart) {
    $.ajax({
      url: base_url+'/api/order',
      type: 'POST',
      data: {
        line: cart
      },
      success: function(order){
        if(order.status == 'success'){
          window.location.href = order.invoice_url;
        }else{
          $('#mypop').show();			
          $('.closeup_icon').click(function(){
            $('#mypop').hide();
            $('#checkout_submit').removeClass("disabled btn--loading");
          });
        }
      }
    });
  });
});


function AppendSpecialProduct(){
  var $location_count = 0;
  $('.special_product').each(function(){
    var $parent_this = $(this);
    $(this).find('.fields_count_2').each(function(){
      var $divs_count = $(this).children('div').length;
      if($divs_count == 2){
        $location_count = $location_count + 1;
        if($location_count > 1){
          $(this).prepend('<div class="repitation_box"><label><input type="checkbox" checked>Click here, if you already entered the required data or if you have already uploaded your player name/jersy information.</label></div>');
        }else{
          $(this).addClass('tetra_first_selector')
        }

        $(this).append('<div class="append_box"></div>');
      }
    });
  });
}
var get_real_time_qty = $('form[action="/cart/add"] input[name="quantity"]').val();
function RepeartFields(qty){
  if(qty > get_real_time_qty){
    get_real_time_qty = qty;
    $('.special_product .fields_count_2').each(function(){
      var $divs_count = $(this).children('div.sub_option_data').length;
      if($divs_count >= 2){
        var div1 = $(this).find('.sub_option_data').eq(0).html();
        var div2 = $(this).find('.sub_option_data').eq(1).html();
        $(this).find('.append_box').append('<div class="tetra_append_opttt"><div class="sub2 sub_option_data" data-index="'+qty+'">'+div1+'</div><div class="sub2 sub_option_data" data-index="'+qty+'">'+div2+'</div></div>');

      }
    });

    setTimeout(function(){
      var index = 0;

      $('.tetra_append_opttt').each(function(){
        index++
        var get_input_name1 = $(this).find('.sub_option_data').eq(0).find('input').data('a-name')+index;
        var get_input_name2 = $(this).find('.sub_option_data').eq(1).find('input').data('a-name')+index;

        $(this).find('.sub_option_data').eq(0).find('input').attr('name','properties['+get_input_name1+']');
        $(this).find('.sub_option_data').eq(1).find('input').attr('name','properties['+get_input_name2+']');

      });
    },10);

  }else{
    get_real_time_qty = qty;
    $('.special_product .fields_count_2').each(function(){
      var $divs_count = $(this).children('div.sub_option_data').length;
      if($divs_count >= 2){
        var get_length_opt = $(this).find('.append_box .tetra_append_opttt').length;
        $(this).find('.append_box .tetra_append_opttt:nth-child('+get_length_opt+')').remove()
      }
    });
  }
}

$('body').on('input','.special_product .fields_count_2 input',function(){
  var get_length = $(this).parents('.fields_count_2').find('.repitation_box').length;

  if(get_length < 1 ){
    var get_text = $(this).prev().text().trim();
    var get_above_val = $(this).val();
    var get_index = $(this).parent().data('index');
    $('.special_product .fields_count_2 .sub_option_data input').each(function(){
      if($(this).parents('.fields_count_2').find('.repitation_box input').prop("checked") == true){
        var get_inner_text = $(this).prev().text().trim();
        if(get_text == get_inner_text && $(this).parent().data('index') == get_index){
          $(this).val(get_above_val);
        }
      }
    });
  }
  else{

  }

  CalculateFinalPrice();
});

$('body').on('change','.repitation_box input',function() {
  if ($(this).prop('checked') == true) {
    var get_selector = $(this).parents('.fields_count_2');

    $('.tetra_first_selector input').each(function(){
      var get_text = $(this).prev().text().trim();
      var get_above_val = $(this).val();
      var get_index = $(this).parent().data('index');

      get_selector.find('.sub_option_data input').each(function(){
        var get_inner_text = $(this).prev().text().trim();
        if(get_text == get_inner_text && $(this).parent().data('index') == get_index){
          $(this).val(get_above_val);
        }
      });
    });
  }

});


var ColorsAvalible = {Black:"#000", White:"#fff", Yellow:"#ffff00",Green:"#008000",Pink:"#ffc0cb",Red:"#ff0000",Grey:"#808080",Cyan:"#00FFFF",DarkBlue:"#0000A0",LightBlue:"#ADD8E6",Purple:"#800080",Lime:"#00FF00",Burgundy:"#8C001A",Blue:"#0000FF",Lime:"#00FF00",Magenta:"#FF00FF",Silver:"#C0C0C0",Gray:"#808080",Orange:"#FFA500",Brown:"#A52A2A",Maroon:"#800000",Olive:"#808000",Gold:"#ffd700",Bronze:"#CD7F32"};

$('.variant-input-wrap label').click(function(event){
  $('.variant-input-wrap label').removeAttr("active-label")
  $(this).attr("active-label","true")
  var myvar = $('.variant-input-wrap input[type="radio"]:checked').attr('value')
  var activeLbelColor = $('.variant-input-wrap input[type="radio"] + label[active-label="true"]').html()
  $('.tetra_append_input span.previewtext').css("background",ColorsAvalible[activeLbelColor])
  if((activeLbelColor=='White')||(activeLbelColor=='Yellow'))
  {
    $('.tetra_append_input span.previewtext').css("color","black")
  }
  else
  {
    $('.tetra_append_input span.previewtext').css("color","white")
  }
})

$('body').on('change','.tetra_first_selector input[data-a-name="Front:Jersy Number(Name)"]',function(){
  var get_indexjery = $(this).parent().data('index');
  var get_valjery = $(this).val();
  if(get_valjery != ''){
    $('.tetra_append_input.add_extra > div[data-index="'+get_indexjery+'"] .engravingheading').find('.customjerytetname').remove();
    $('.tetra_append_input.add_extra > div[data-index="'+get_indexjery+'"] .engravingheading').append('<span class="customjerytetname">('+get_valjery+')</span>');
  }

});


function CalculateFinalPrice(){
  var product_price = parseFloat($('#calculated_price').val());
  var per_unit_price = parseFloat($('#per_unit_price').val());
  var all_price = parseFloat($('#all_price').val());
  var quantity = $('.product__quantity--button input').val();

  var final_subtotal = quantity * product_price;
  final_subtotal = final_subtotal.toFixed(2);
  $('#subtotal_price').html('<span class="money">$'+final_subtotal+'</span>');

  var cst_charges = (per_unit_price * quantity) + parseFloat(all_price);
  cst_charges = cst_charges.toFixed(2)
  $('#setup_charges_value').html('<span class="money">$'+cst_charges+'</span>');


  var total_price = parseFloat(final_subtotal) + parseFloat(cst_charges);
  total_price = total_price.toFixed(2);
  $('#total_price').html('<span class="money">$'+total_price+'</span>');
}


// Affiliate Module 

if(window.location.href == 'https://trophyking.ca/account')
{
  var customer_id = meta.page.customerId;
  //var base_url = "https://trophyking.test";
  $.ajax({
    url:base_url+"/api/affiliate/"+customer_id,
    type: 'GET',
    success: function(res){
      if(res.status == 'success')
      {
        $('.js-affiliate-btn').show();
        $('.js-affiliate-wrapper').show();

      }
    }
  });
}


if(window.location.href == 'https://trophyking.ca/pages/affiliate')
{
  var customer_id = meta.page.customerId;
  //var base_url = "https://trophyking.test";
  $.ajax({
    url:base_url+"/api/affiliate-details/"+customer_id,
    type: 'GET',
    success: function(res){
      if(res.status == 'success')
      {
        $('.js-affiliate-wrapper').append(res.html);

      }
    }
  });


  $(document).on('click', '.withdrawal-btn', function() {
    var amount = $('.withdrawal-amount').val();
    var alert_box = $('.alert-text');
    var btn = $(this);

    alert_box.hide();
    btn.prop('disabled',true);


    if(!amount)
    {
      alert_box.text('Please Enter some amount');
      alert_box.show();
      btn.prop('disabled',false);

      return false;
    }

    $.ajax({
      url:base_url+`/api/withdrawals/save?customer_id=${customer_id}&amount=${amount}`,
      type: 'GET',
      success: function(res){
        if(res.status == 'success')
        {
          alert_box.text(res.message);
          alert_box.show();
          location.reload();
        }
        else if(res.status == 'error') 
        {
          alert_box.text(res.message);
          alert_box.show();
          btn.prop('disabled',false);
          return false;
        }
      }
    });


  });

  $(document).on('click', '.js-clipboard-btn', function() {
    var $temp = $("<input>");
    var selector = $(this).data('selector');
    $("body").append($temp);

    $temp.val($(`#${selector}`).text()).select();
    document.execCommand("copy");
    $temp.remove();

  });


  $(document).on('click','.withdrawal-popup-btn', function() {
    $("#withdrawal-popup").show();

  });

  $(document).on('click', '.close', function() {
    $("#withdrawal-popup").hide();
  });


  window.onclick = function(event) {
    if (event.target == modal) {
      $("#withdrawal-popup").hide();
    }
  }
}
